import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RightIndent02 = function RightIndent02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 9.25H3M12 4H3m18 10.75H3M21 20H3M19.72 2.96l-3.8667 2.9c-.2895.217-.4342.3256-.486.4587a.5.5 0 0 0 0 .3625c.0518.133.1965.2416.486.4588l3.8667 2.9c.412.3089.618.4634.7904.4598a.5.5 0 0 0 .3833-.1916C21 10.1724 21 9.9149 21 9.4V3.6c0-.515 0-.7725-.1063-.9083a.5.5 0 0 0-.3833-.1916c-.1724-.0036-.3784.1509-.7904.4598"
    })
  }));
};
export default RightIndent02;